<template>
    <div v-if="showNotification" class="expiry-notification">
      <h4>Stock Expiry Alert</h4>
      <ul>
        <li><strong>Expired Items:</strong> {{ expiredItems }} items</li>
        <li><strong>Items Soon Expiring:</strong> {{ soonExpiringItems }} items</li>
      </ul>
      <p>
        Consider reviewing stock for Items  that are nearing their expiration date or have expired.
      </p>
      <router-link to="/stock/expired" class="btn btn-warning mt-3 ml-5">
        <i class="fa fa-list"></i> Click to View Expired items
        </router-link>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      expiredItems: {
        // type: Number,
        default: 0
      },
      soonExpiringItems: {
        type: Number,
        default: 0
      },
      showNotification: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  .expiry-notification {
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 15px;
    margin: 15px 0;
    color: #333;
  }
  
  .expiry-notification h4 {
    margin-top: 0;
    color: #f0ad4e; /* Orange color for alert */
  }
  
  .expiry-notification ul {
    list-style-type: none;
    padding-left: 0;
  }
  
  .expiry-notification li {
    margin: 5px 0;
  }
  
  .expiry-notification p {
    margin-top: 10px;
    font-weight: bold;
  }
  </style>
  